<template>
	<div class="parte">

		<input type="text" maxlength="80" v-model="value.título" placeholder="Escribe aquí un título para el formulario" class="titulo-formulario">

		<ParteFormularioElemento
			v-for="(e, i) in value.elementos"
			:key="`fe${i}`"
			v-model="value.elementos[i]"
			:cantidadDeElementos="value.elementos.length"
			:posición="i"
			@eliminar="eliminarElemento(i)"
			@subir="subirElemento(i)"
			@bajar="bajarElemento(i)"
		></ParteFormularioElemento>

		<div
			v-if="value.aceptación.requerida"
			style="margin-left: 35px; margin-bottom: 0.8em;"
		>
			<input type="checkbox" disabled style="width: unset; margin-right: 5px;">
			<span style="text-decoration: underline">{{ value.aceptación.leyenda }}.</span>
		</div>

		<v-btn small tile outlined color="indigo" style="margin-left: 35px; margin-bottom: 0.8em; visibility: hidden" class="agregar-campo" @click="agregandoElemento = true">
      <v-icon left>mdi-plus</v-icon> Agregar un nuevo campo
    </v-btn>

		<div class="aceptacion" style="display: none">
			<v-switch
				v-model="value.aceptación.requerida"
				label="Requerir aceptación de términos y condiciones o políticas"
			></v-switch>

			<v-btn
				small
				tile
				outlined
				style="margin-bottom: 0.8em;"
				v-if="value.aceptación.requerida"
				@click="estableciendoAceptación = true"
			>
				<v-icon left>mdi-plus</v-icon> Establecer contenido de aceptación
			</v-btn>
		</div>

		<input type="submit" value="Enviar" style="margin-left: 35px; width: calc(100% - 35px)" disabled>

		<div class="destinatario" style="margin-left: 35px; margin-top: 20px; width: calc(100% - 35px); visibility: hidden">
			<label>Correo al cual enviar el mensaje:</label>
			<input type="email" v-model="value.destinatario">
		</div>

		<v-dialog
      v-model="agregandoElemento"
      max-width="500"
    >
      <v-card>
				<v-card-title>Agrega un nuevo campo al formulario</v-card-title>
				<v-card-text>
					<v-text-field label="Nombre del campo" v-model="títuloElementoNuevo"></v-text-field>
					<v-select
						 v-model="tipoElementoNuevo"
						:items="tiposDeCampos"
						append-icon="mdi-menu-down"
						label="Tipo"
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="deep-purple accent-4" @click="agregarElemento()" :disabled="!títuloElementoNuevo || !tipoElementoNuevo">Agregar</v-btn>
					<v-btn text @click="agregandoElemento = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

		<v-dialog
      v-model="estableciendoAceptación"
      max-width="1200"
			scrollable
			persistent
    >
      <v-card>
				<v-card-title>Establecer términos y condiciones o políticas</v-card-title>
				<v-card-text>
					<v-text-field
						outlined
						label="Leyenda"
						v-model="value.aceptación.leyenda"
						class="mt-5"
					></v-text-field>
					<v-textarea
						outlined
						:rows="20"
						label="Términos y condiciones o políticas de aceptación"
						v-model="value.aceptación.contenido"
					></v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="success" @click="estableciendoAceptación = false">Finalizar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

	</div>
</template>

<script>

import ParteFormularioElemento from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteFormularioElemento'

export default {
  name: 'ParteFormulario',

  data: () => ({
		tiposDeCampos: [
			{ text: 'Texto', value:'texto' },
			{ text: 'Correo electrónico', value:'correo' },
			{ text: 'Número telefónico', value:'teléfono' },
			{ text: 'Texto largo', value:'texto_largo' },
		],

		agregandoElemento: false,
		títuloElementoNuevo: '',
		tipoElementoNuevo: 'texto',

		estableciendoAceptación: false,
	}),

	components: {
		ParteFormularioElemento
	},
	
	props: {
		value: {
			type: Object,
			default: function() {
				return {
					título: 'Contáctenos',
					destinatario: '',
					elementos: [],
					aceptación: {
						requerida: false,
						leyenda: 'Acepto los términos y condiciones',
						contenido: ''
					}
				}
			}
		}
	},

	beforeMount: function() {
		if (!this.value.aceptación) {
			this.$set(this.value, 'aceptación', { requerida: false, leyenda: 'Acepto los términos y condiciones', contenido: '' })
		}
	},

	methods: {
		agregarElemento: function() {
			this.value.elementos.push({
				tipo: this.tipoElementoNuevo || 'texto',
				título: this.títuloElementoNuevo,
				identificador: Math.random().toString().split('.')[1],
				opciones: []
			})

			this.agregandoElemento = false
			this.títuloElementoNuevo = ''
			this.tipoElementoNuevo = 'texto'
		},
		eliminarElemento: function(i) {
			this.$delete(this.value.elementos, i)
		},
		subirElemento: function(i) {
			let el = this.value.elementos[i]
			this.value.elementos.splice(i, 1)
			this.value.elementos.splice(i-1, 0, el)
		},
		bajarElemento: function(i) {
			let el = this.value.elementos[i]
			this.value.elementos.splice(i, 1)
			this.value.elementos.splice(i+1, 0, el)
		},
	}

};

</script>

<style scoped>

.titulo-formulario {
	border: none;
	font-size: 1.3em;
	padding: 0.3em 0.1em;
	margin: 0 0 10px 0;
	outline: 0;
	width: 100%;
	border-bottom: 1px dashed transparent;
}

.titulo-formulario:hover, .titulo-formulario:focus {
	border-bottom: 1px dashed silver;
}

.parte:hover .agregar-campo, .parte:hover .destinatario {
	visibility: unset !important;
}

.parte:hover .aceptacion {
	display: block !important;
	margin-left: 35px;
}

</style>